import type { ActionCodeSettings } from 'firebase/auth';

/** Production web app origin for password-reset email links. */
export const PRODUCTION_WEB_APP_ORIGIN = 'https://app.trovepile.com';

/** Staging web app origin (Firebase Console action URL must match). */
export const STAGING_WEB_APP_ORIGIN = 'https://staging.app.trovepile.com';

/**
 * Canonical web origin for auth action links — never use extension or dev
 * origins in emails sent from extension popup or mobile.
 */
export function resolveWebAppOrigin(): string {
  const fromEnv =
    typeof import.meta !== 'undefined'
      ? (import.meta.env.VITE_WEB_APP_ORIGIN as string | undefined)
      : undefined;
  if (fromEnv?.trim()) {
    return fromEnv.replace(/\/+$/, '');
  }

  if (typeof window !== 'undefined') {
    const { protocol, hostname, host } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return `${protocol}//${host}`;
    }
    if (hostname.includes('staging')) {
      return STAGING_WEB_APP_ORIGIN;
    }
  }

  return PRODUCTION_WEB_APP_ORIGIN;
}

/** Firebase `sendPasswordResetEmail` action code settings (shared contract). */
export function buildPasswordResetActionCodeSettings(): ActionCodeSettings {
  const webOrigin = resolveWebAppOrigin();
  return {
    url: `${webOrigin}/login`,
    handleCodeInApp: true,
  };
}
